import { forwardRef } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import {
  POPOVER_CONTENT_CLASS,
  POPOVER_SIDE_OFFSET,
  type TPopoverContentElement,
  type TPopoverContentProps,
} from "@/ui/components/overlay/Popover/Popover.config";
import { cn } from "@/ui/lib/utils";

export const PopoverContent = forwardRef<TPopoverContentElement, TPopoverContentProps>(
  (
    {
      align = "center",
      children,
      className,
      sideOffset = POPOVER_SIDE_OFFSET,
      ...props
    },
    ref,
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        data-component="PopoverContent"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          POPOVER_CONTENT_CLASS,
          "origin-[--radix-popover-content-transform-origin]",
          "animate-in fade-in-0 zoom-in-95",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
          "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
          "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className,
        )}
        {...props}
      >
        { children }
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  ),
);

PopoverContent.displayName = PopoverPrimitive.Content.displayName;
